/* istanbul ignore file */
import './examState.factory';
import './exam.factory';
import './attempt.factory';
import './proctoringSettings.factory';
import './examAccessToken.factory';
